import axios from 'axios';

export const getCompanySectors = async (lang) => {
  const { data } = await axios.get(`/company-sectors?lang=${lang}`);

  return data.sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
  );
};
